import { CacheableDataObject } from './CacheableDataObject';
import PostGroupTopic from './PostGroupTopic';

export default class PostGroup extends CacheableDataObject {
	beforeConstruct() {
		this.topics = [];
	}
}

PostGroup.prototype.dataLocationParsers = {
	topics: (group, data) => {
		group.topics = data.topics.map((topic) => {
			return PostGroupTopic.create(topic);
		});
	},
};